import {
  MutationTree,
} from 'vuex';

import {
  AuthMutationsTypesEnum,
} from '@/store/modules/auth/mutation-types';
import {
  AuthState,
} from '@/store/modules/auth/types';

export const mutations: MutationTree<AuthState> = {

  [AuthMutationsTypesEnum.UPDATE_AUTH_STATUS]: (state: AuthState, value: boolean) => {
    state.isAuthenticated = value;
  },

};
